// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2N5TN","select":"Header_select__28dgx","clinic":"Header_clinic__fAF9B"};